import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";
import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import RewardList from "@/modules/recognition/admin/components/RewardList";
import { fetchValuesQueryOptions } from "@/modules/recognition/admin/services";

export const Route = createFileRoute(
  "/admin/_panel/_recognition/recognition/rewards/",
)({
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(context.user, "recognition.recognition-reward.view");

    return {
      crumb: [
        {
          label: context.t("Rewards", { ns: "recognition.shared" }),
        },
      ],
    } satisfies ChildRouteContext;
  },
  loader: (opts) =>
    opts.context.queryClient.prefetchQuery(fetchValuesQueryOptions()),
  component: Component,
});

function Component() {
  const { t } = useTranslation("recognition.admin");
  return (
    <Container
      title={t("Manage Rewards")}
      description={t("Manage, create, or edit rewards.")}
    >
      <RewardList />
    </Container>
  );
}
